import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from '../config/axios';
import {
    FETCH_USER_PROFILE_BASE,
    FETCH_USER_PROFILE_BASE_FETCHING,
    FETCH_USER_PROFILE_BASE_SUCCESS,
    FETCH_USER_PROFILE_BASE_FAIL
} from '../actions/ActionTypes';

// Worker
export function* fetchUserProfileBaseSaga() {
    yield put({
        type: FETCH_USER_PROFILE_BASE_FETCHING
    });

    try {
        const response = yield call(gcApi.get, `/userprofile-service/userprofile/userProfileBase`);

        yield put({
            type: FETCH_USER_PROFILE_BASE_SUCCESS,
            data: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_USER_PROFILE_BASE_FAIL,
            userProfileBase: null
        });
    }
}
// Watcher
export const userProfileBaseSagas = [takeEvery(FETCH_USER_PROFILE_BASE, fetchUserProfileBaseSaga)];
